import {FieldArray, Form, Formik, useFormikContext} from 'formik';
import React from 'react';
import styled from 'styled-components';

export const FilterFormSetup = ({render, size, filters, applyFilter}) => {
    return (
        <FilterAside className={size}>
            <Formik initialValues={{filters: filters}} onSubmit={applyFilter}>
                <FilterFormArray render={render} />
            </Formik>
        </FilterAside>
    );
};

const FilterFormArray = ({render}) => {
    const {handleSubmit} = useFormikContext();

    const handleEnter = (ev) => {
        if (ev.key === 'Enter') {
            ev.preventDefault();
            handleSubmit();
        }
    };

    return (
        <Form onKeyDown={handleEnter} onSubmit={handleSubmit}>
            <FieldArray name="filters" render={render} />
        </Form>
    );
};

export const FilterAside = styled.div`
    position: relative;
    width: var(--aside-width);
`;
